// TODO - eventaully move over everything to these parts of the tree

export function state(initialState) {
  return {
    rfqMetadata: {},
    onboardingMetadata: {},
  };
}
